import { render, staticRenderFns } from "./AccreditationGenerate.vue?vue&type=template&id=0a0fa8b6&scoped=true&"
import script from "./AccreditationGenerate.vue?vue&type=script&lang=js&"
export * from "./AccreditationGenerate.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationGenerate.vue?vue&type=style&index=0&id=0a0fa8b6&scoped=true&lang=css&"
import style1 from "./AccreditationGenerate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fa8b6",
  null
  
)

export default component.exports